module.exports = __webpack_public_path__ + "img/cross-road.674dfeff.png";